// startpage-option.service.ts
import { Injectable, signal } from '@angular/core';

export type StartpageOption = 'Status' | 'Balance';

@Injectable({ providedIn: 'root' })
export class StartpageOptionService {
  private selectedOption = signal<StartpageOption>('Status');

  // Read-only version for components
  selectedStartpageoption = this.selectedOption.asReadonly();

  setOption(option: StartpageOption) {
    this.selectedOption.set(option);
  }
}
